var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "101px",
    viewBox: "0 0 113 101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aide",
    transform: "translate(-293.000000, -223.000000)",
    stroke: "#9EBE4A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow1",
    transform: "translate(349.602803, 273.705012) rotate(-160.000000) translate(-349.602803, -273.705012) translate(305.598271, 239.487869)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line-21",
    strokeLinejoin: "round",
    transform: "translate(5.311366, 21.783085) rotate(-150.000000) translate(-5.311366, -21.783085) ",
    points: "1.44147006 17.8632092 8.92734589 17.9194583 9.18126127 25.7029602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6168288,20.6065366 C16.707786,36.9053746 29.8020215,45.4088706 45.2200081,47.6239572 C55.4986659,49.1006816 69.5421815,42.5518377 87.3505549,27.9774256",
    id: "Line-8",
    transform: "translate(45.483692, 34.217142) scale(1, -1) rotate(-33.000000) translate(-45.483692, -34.217142) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftTop);
export default __webpack_public_path__ + "static/media/arrow_left_top.d412bb68.svg";
export { ForwardRef as ReactComponent };